import { render, staticRenderFns } from "./ConnectPeople.vue?vue&type=template&id=91ecf33e&scoped=true&"
import script from "./ConnectPeople.vue?vue&type=script&lang=js&"
export * from "./ConnectPeople.vue?vue&type=script&lang=js&"
import style0 from "./ConnectPeople.vue?vue&type=style&index=0&id=91ecf33e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "91ecf33e",
  null
  
)

export default component.exports